import React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';
import { FooterProps } from './Footer.types';
import { useFooterBundle } from 'src/providers/PantherLocalizationProvider/PantherLocalizationProvider';

const Footer: React.VFC<FooterProps> = ({
  copyright,
  links,
  toggleView,
  isMobile,
  isMobileWebView,
  isForceDesktop,
}) => {
  const bundle = useFooterBundle();

  // do not show the footer on the Seller App
  if (isMobileWebView) {
    return null;
  }
  /*
    1) If the user is on a mobile device
    And the page is mobile-optimized
    And forceDesktop is not set
    Show the mobile nav, mobile footer, and mobile viewport
    Show the "View desktop site" footer link
  */
  if (isMobile && !isForceDesktop) {
    return (
      <Mobile
        isFooterLinkEnabled
        links={links}
        copyright={copyright}
        toggleText={bundle.getMessage('footer-toggle-to-desktop-button-text')}
        toggleView={toggleView}
      />
    );
  }

  /*
    2) If the user is on a mobile device
    And the page is mobile-optimized
    And forceDesktop is set
    Show the desktop nav, desktop footer, and desktop viewport
    Show the "View mobile site" footer link
  */
  if (isMobile && isForceDesktop) {
    return (
      <Desktop
        isFooterLinkEnabled
        isMobile // revist this when looking at mocks
        links={links}
        copyright={copyright}
        toggleText={bundle.getMessage('footer-toggle-to-mobile-button-text')}
        toggleView={toggleView}
      />
    );
  }

  /*
    3) Other conditions, render desktop footer
  */
  return <Desktop links={links} copyright={copyright} />;
};

export default Footer;
